/**
 * Third-Party Script Loader
 * Lazy loads non-critical third-party scripts after user interaction
 * Improves LCP and TTI by deferring heavy scripts
 */

(function() {
  'use strict';
  
  // Track loaded scripts to prevent duplicates
  var loadedScripts = new Set();
  
  /**
   * Load a script with interaction-based triggering
   * @param {string} src - Script URL
   * @param {Object} options - Loading options
   */
  function loadScript(src, options) {
    options = options || {};
    
    if (loadedScripts.has(src)) {
      if (options.onLoad) options.onLoad();
      return;
    }
    
    var script = document.createElement('script');
    script.src = src;
    
    if (options.type) script.type = options.type;
    if (options.async !== false) script.async = true;
    if (options.defer) script.defer = true;
    
    if (options.onLoad) {
      script.onload = options.onLoad;
    }
    
    if (options.onError) {
      script.onerror = options.onError;
    }
    
    (options.target || document.head).appendChild(script);
    loadedScripts.add(src);
  }
  
  /**
   * Sierra Chat - Load on interaction or after delay
   */
  function loadSierra() {
    loadScript('https://sierra.chat/agent/jbJK3akBkgvT4WkBkgvUH3-P6gM49_bqsnVyZfhBlgw/embed', {
      type: 'module'
    });
  }
  
  /**
   * Setup interaction-based loading
   */
  function setupInteractionLoading() {
    var interactionEvents = ['scroll', 'mousemove', 'touchstart', 'keydown'];
    var triggered = false;
    
    function onInteraction() {
      if (triggered) return;
      triggered = true;
      
      // Remove listeners
      interactionEvents.forEach(function(event) {
        window.removeEventListener(event, onInteraction);
      });
      
      // Load Sierra
      loadSierra();
    }
    
    // Listen for interactions
    interactionEvents.forEach(function(event) {
      window.addEventListener(event, onInteraction, { once: true, passive: true });
    });
    
    // Fallback: load after 5 seconds
    setTimeout(function() {
      if (!triggered) onInteraction();
    }, 5000);
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupInteractionLoading);
  } else {
    setupInteractionLoading();
  }
  
  // Export for manual triggering if needed
  window.loadThirdPartyScript = loadScript;
})();
